import { TransactionTypes } from '../../../_mock/@types';

export const calculateTotalAmount = (array: TransactionTypes[]) => {
  const totalAmount = array.reduce(
    (prevValue, currValue) => prevValue + currValue.amount,
    0
  );
  return totalAmount;
};
